import { createClientComponentClient } from '@supabase/auth-helpers-nextjs';

// Create and export the Supabase client for client-side usage
export const createClient = () => {
  // Check for auth bypass flag
  const isAuthBypassed = typeof window !== 'undefined' && (
    localStorage.getItem('auth_bypass_active') === 'true' || 
    window.forceDashboardRender === true
  );
  
  if (isAuthBypassed) {
    console.log('Supabase client: Using mock client due to auth bypass');
    
    // Create mock user ID if none exists
    if (typeof window !== 'undefined' && !localStorage.getItem('auth_user_id')) {
      localStorage.setItem('auth_user_id', 'mock-user-' + Date.now());
    }
    
    // Mock user ID
    const mockUserId = typeof window !== 'undefined' ? 
      localStorage.getItem('auth_user_id') || 'mock-user-id' : 
      'mock-user-id';
    
    // Return a mock client that pretends to be authenticated
    return {
      auth: {
        getSession: () => Promise.resolve({ 
          data: { 
            session: {
              user: {
                id: mockUserId,
                email: 'mock@example.com',
                role: 'authenticated',
                app_metadata: { provider: 'email' },
                user_metadata: { full_name: 'Bypass User' },
              }
            }
          }, 
          error: null 
        }),
        onAuthStateChange: (callback: any) => {
          // Simulate auth state change event on next tick
          setTimeout(() => {
            callback('SIGNED_IN', { 
              user: {
                id: mockUserId,
                email: 'mock@example.com',
                role: 'authenticated',
                app_metadata: { provider: 'email' },
                user_metadata: { full_name: 'Bypass User' },
              }
            });
          }, 0);
          
          // Return dummy subscription
          return { data: { subscription: { unsubscribe: () => {} } } };
        },
        signOut: () => Promise.resolve({ error: null }),
      },
      from: (table: string) => ({
        select: (columns: string = '*') => {
          console.log(`Mock Supabase: select ${columns} from ${table}`);
          
          // Return mock data for common tables
          if (table === 'profiles') {
            return {
              eq: () => ({
                maybeSingle: () => Promise.resolve({ 
                  data: { 
                    id: mockUserId,
                    full_name: 'Bypass User',
                    email: 'mock@example.com',
                  }, 
                  error: null 
                })
              })
            };
          }
          
          if (table === 'user_access_levels') {
            return {
              eq: () => ({
                maybeSingle: () => Promise.resolve({ 
                  data: { 
                    user_id: mockUserId,
                    access_levels: {
                      id: 'mock-access-level',
                      name: 'Admin',
                      page_access: ['*'],
                      brand_access: { type: 'all' },
                      rls_permissions: { '*': ['*'] }
                    } 
                  }, 
                  error: null 
                })
              })
            };
          }
          
          // Default mock response for any other table
          return {
            order: () => ({
              limit: () => Promise.resolve({ data: [], error: null }),
              eq: () => Promise.resolve({ data: [], error: null }),
              in: () => Promise.resolve({ data: [], error: null }),
            }),
            eq: () => Promise.resolve({ data: [], error: null }),
            in: () => Promise.resolve({ data: [], error: null }),
            limit: () => Promise.resolve({ data: [], error: null }),
          };
        },
        insert: () => Promise.resolve({ data: { id: 'mock-id' }, error: null }),
        update: () => Promise.resolve({ data: { id: 'mock-id' }, error: null }),
        delete: () => Promise.resolve({ data: { id: 'mock-id' }, error: null }),
      })
    } as any;
  }
  
  // Otherwise create the real client
  return createClientComponentClient();
}; 